export const name = 'siteInteractionsService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-interactions'
